import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableInfoRapidAlert extends Layout {
    sourceTableInfo: DataSource;
    tblTableInfo: Table;
}
